<div class="container" *ngIf="userInfo">
  <button *ngIf="userInfo.avatar" mat-fab class="user-img"></button>
  <div *ngIf="!userInfo.avatar"  class="avatar" style="background-color: #dedede;">
    <span style="font-weight: 600;font-size: larger;">{{userInfo.firstName.charAt(0)}}{{userInfo.lastName.charAt(0)}}</span>
 </div>
  <h2 style="margin-bottom: 0px;">{{userInfo.firstName+" "+userInfo.lastName}}</h2>
  <p>{{userInfo.role}}</p>
</div>
